module.exports = __webpack_public_path__ + "static/media/cloud.6eb86bc1.jpg";